import withDraft from '@/utils/draftHelper';
import { closeDatasetCollectionState } from './state';
import actions from '../../settings/constants';

const closeSettingsDatasetCollection = withDraft((draft, { code }) => {
  closeDatasetCollectionState(draft, { category: 'settings', code });
});

export default {
  [actions.CLOSE_DATASET_SETTINGS]: closeSettingsDatasetCollection,
};
